import BaseIcon from './BaseIcon';
import React = require('react');

export default class ShopIcon extends BaseIcon {
    protected renderIcon() :React.ReactNode {
        return <span className="material-icons" style={{ fontSize: this.props.fontSize }}>shopping_cart</span>;
    }
}
